import PropTypes from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet-async';

import { pageMetadata } from 'shared/pageMetadata';

const PageHelmet = ({ page }) => (
  <Helmet
    title={pageMetadata[page].title}
    meta={[{ name: 'description', content: pageMetadata[page].description }]}
  />
);

PageHelmet.propTypes = {
  page: PropTypes.string.isRequired,
};

PageHelmet.displayName = 'PageHelmet';

export default PageHelmet;
